import { RefObject, useLayoutEffect, useState } from 'react';

/** Room taken at the bottom of a phone screen: the tab bar and a form's sticky buttons */
const PHONE_BOTTOM_CHROME = 140;
const DESKTOP_BOTTOM_GAP = 16;
/** The top bar */
const TOP_CHROME = 64;

/**
 * Whether a dropdown should open above its field: when its panel would not fit between the
 * field and the bottom of the screen (on phones, above the tab bar and sticky buttons) and
 * there is more room above. A field low on a phone screen otherwise opens its list under the
 * tab bar, where only the page scroll reveals it.
 */
export function useOpensUp(open: boolean, anchorRef: RefObject<HTMLElement | null>, panelHeight: number): boolean {
  const [up, setUp] = useState(false);

  useLayoutEffect(() => {
    if (!open) return;
    const rect = anchorRef.current?.getBoundingClientRect();
    if (!rect) return;
    const desktop = typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 1024px)').matches;
    const below = window.innerHeight - rect.bottom - (desktop ? DESKTOP_BOTTOM_GAP : PHONE_BOTTOM_CHROME);
    const above = rect.top - TOP_CHROME;
    setUp(below < panelHeight && above > below);
  }, [open, anchorRef, panelHeight]);

  return open && up;
}
